module.exports = __webpack_public_path__ + "img/8.30439cd3.png";